import { useLazyQuery, useQuery } from '@apollo/client';
import {
  AdminCancelledBookingsTableDocument,
  DownloadRecentBookingsCsvDocument,
} from '@website/types/graphqlOperations';
import { useCallback } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { BookingsTable } from './AdminBookings/AdminBookingsTable';

export default function CancelledBookings() {
  const { loading, data, fetchMore } = useQuery(
    AdminCancelledBookingsTableDocument,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
      // poll every 5 minutes
      pollInterval: 300000,
      variables: {
        limit: 200,
      },
    },
  );

  const [download, { loading: downloading }] = useLazyQuery(
    DownloadRecentBookingsCsvDocument,
    {
      fetchPolicy: 'network-only',
    },
  );

  const downloadCsv = useCallback(async () => {
    const { data: groupsCsv } = await download();
    const { downloadUrl } = groupsCsv.exportRecentBookingsToCSV;
    // Create a link and click it to download the file
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'reviews.csv';
    document.body.appendChild(link);
    link.click();
  }, [download]);

  return (
    <Row>
      <Col xs={12} className="py-2" onClick={downloadCsv}>
        <Button>{downloading ? 'Downloading...' : 'Download CSV'}</Button>
      </Col>
      <Col xs={12}>
        <BookingsTable
          bookings={data ? data.cancelledBookings.items : undefined}
          loading={loading}
          isCancellation
        />
      </Col>

      {data && data?.cancelledBookings?.nextToken && (
        <Col xs={12} className="text-center py-2">
          <Button
            disabled={loading}
            onClick={() => {
              fetchMore({
                variables: {
                  nextToken: data.cancelledBookings.nextToken,
                },
                updateQuery: (prev, { fetchMoreResult }) => {
                  if (!fetchMoreResult) return prev;
                  return {
                    cancelledBookings: {
                      ...fetchMoreResult.cancelledBookings,
                      items: [
                        ...prev.cancelledBookings.items,
                        ...fetchMoreResult.cancelledBookings.items,
                      ],
                    },
                  };
                },
              });
            }}
          >
            {loading ? 'Loading...' : 'Load More Bookings'}
          </Button>
        </Col>
      )}
    </Row>
  );
}
